<ul class="app-info-list">
  @if (environment !== 'production') {
    <li>
      <div class="app-info-column">Name: </div>{{ name }}
    </li>
    <li>
      <div class="app-info-column">Package: </div>{{ id }}
    </li>
  }

  <li>
    <div class="app-info-column">Version: </div>{{ version }} ({{ build }})
  </li>
  <li>
    <div class="app-info-column">Device: </div>{{ device }}
  </li>
  <li>
    <div class="app-info-column">OS: </div>{{ os }}
  </li>

  @if (environment !== 'production') {
    <li>
      <div class="app-info-column">Environment: </div>{{ environment }}
    </li>
  }
</ul>
